import {getMeta} from '../utils';
import {ref} from 'vue';
import rootLogger from '../log';

const log = rootLogger.getLogger('composables.useMetaTagJsonContent');

export function useMetaTagJsonContent(metaTagName)
{
    // TODO: this should not return a ref, it will never change
    const metaTagContent = ref(null);
    try {
        metaTagContent.value = JSON.parse(getMeta(metaTagName));
    } catch (exception) {
        log.error(`${metaTagName} could not be loaded either the meta-tag is not available or it has no valid json content.`);
        throw exception;
    }

    return metaTagContent;
}
